module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.signalReady) ? _c('ViewSitterReservationComponent') : _c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Preparing connection...")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n      if this takes too long, it could be your network provider has a proxy or\n      firewall preventing chat to be established, or use a different browser\n      for this session as we have seen some features being blocked on old\n      Safari and Internet Explorer. Alternatively\n      "), _c('a', {
    attrs: {
      "href": "https://www.dupaws.com/contact-support"
    }
  }, [_vm._v(" contact support ")]), _vm._v("\n      if the issue persist.\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cf0b2d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Reservation/ViewSitterReservation.vue
// module id = 620
// module chunks = 2